"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ConfigurationSchema: true,
  ConfigurationReference: true
};
Object.defineProperty(exports, "ConfigurationSchema", {
  enumerable: true,
  get: function get() {
    return _configurationSchema.ConfigurationSchema;
  }
});
Object.defineProperty(exports, "ConfigurationReference", {
  enumerable: true,
  get: function get() {
    return _configurationSchema.ConfigurationReference;
  }
});

var _configurationSchema = require("./configurationSchema");

var _util = require("./util");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _util[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});